import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import MultiStepForm from "./MultiStepForm";

export default function CarTypeSelection({ openApply }) {
  const [selectedCar, setSelectedCar] = useState(null);

  // ✅ Auto-open modal when user clicks “Apply Now” from anywhere
  useEffect(() => {
    if (openApply) {
      setSelectedCar(" "); // open modal with no specific car selected
    }
  }, [openApply]);

  const vehicles = [
    { name: "Sedan", img: "/car-sedan.png" },
    { name: "Truck", img: "/car-truck.png" },
    { name: "SUV", img: "/car-suv.png" },
    { name: "Mini-Van", img: "/car-van.png" },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-[#0a2545] to-[#0d5e63] text-center relative overflow-hidden">
      {/* Background luxury glow effect */}
      <div className="absolute inset-0 opacity-30 blur-3xl bg-[radial-gradient(circle_at_50%_50%,_rgba(0,255,200,0.15),_transparent_70%)]" />

      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative text-4xl md:text-5xl font-extrabold text-white mb-16 tracking-tight"
      >
        Choose Your Car Type for Financing
      </motion.h2>

      <div className="relative container mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {vehicles.map((v, i) => (
          <motion.div
            key={v.name}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.15, duration: 0.6 }}
            whileHover={{ scale: 1.05, y: -8 }}
            onClick={() => setSelectedCar(v.name)}
            className="group relative cursor-pointer rounded-3xl overflow-hidden shadow-2xl bg-white/5 backdrop-blur-xl border border-white/10 hover:border-teal-300/70 transition-all duration-500"
          >
            {/* Animated glowing border */}
            <div className="absolute inset-0 bg-gradient-to-r from-teal-400 via-transparent to-transparent opacity-0 group-hover:opacity-20 animate-pulse transition-opacity" />

            {/* Inner card content */}
            <div className="p-8 flex flex-col items-center justify-center space-y-4">
              <motion.img
                src={v.img}
                alt={v.name}
                className="w-40 h-40 object-contain drop-shadow-[0_8px_20px_rgba(0,255,200,0.15)] group-hover:drop-shadow-[0_10px_25px_rgba(0,255,200,0.35)] transition-all"
                whileHover={{ scale: 1.05 }}
              />
              <h3 className="text-2xl font-semibold text-white drop-shadow-sm group-hover:text-teal-300 transition-colors">
                {v.name}
              </h3>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Modal */}
      {selectedCar && (
        <MultiStepForm
          isOpen={!!selectedCar}
          selectedCar={selectedCar}
          onClose={() => setSelectedCar(null)}
        />
      )}
    </section>
  );
}
